const imgUrl = "https://picsum.photos/600/600"

const imagesToBeMocked = [
  "logo_aws.png",
  "logo_sfg.png",
  "logo_ics.png",
  "logo_ffg.png",
  "logo_eit.png",
  "logo_eit_digital.png",
  "logo_eden.png",
  "logo_vest.png",
  "award_7.png",
  "award_2.png",
  "award_4.png",
  "award_1.png",
  "award_11.png",
  "award_10.png",
  "award_9.png",
  "EYScaleLogo.png",
  "logo_erma.png",
  "logo_green_tech.png",
  "logo_european_commission.png",
  "backgroundWorldMap.png",
  "darkCopperInPiles.png",
  "darkCopperInPiles",
  "recycled_Metal_Container.png",
  "Case_studio_1.png",
  "homePageHeroBackground.png",
  "metal-shavings-background.png",
  "About_us_header.png",
  "laptop.png",
  "environment.png",
  "metal-shavings-background-two.png",
]

const createGatsbyImageData = (width, imgUrl) => ({
  layout: "constrained",
  placeholder: {
    fallback: imgUrl,
  },
  backgroundColor: "transparent",
  images: {
    fallback: {
      src: imgUrl,
      srcSet: imgUrl,
      sizes: `(min-width: 166px) 166px, 100vw`,
    },
    sources: [
      {
        srcSet: imgUrl,
        type: "image/webp",
        sizes: `(min-width: 166px) 166px, 100vw`,
      },
    ],
  },
  width: width,
})

const buildEdges = items => {
  const sizes = {
    xxl: 1920,
    xl: 1440,
    lg: 1280,
    md: 768,
    sm: 480,
    node: 166,
  }

  return items.map(item => {
    const edge = {}
    Object.keys(sizes).forEach(size => {
      edge[size] = {
        base: item,
        childImageSharp: {
          gatsbyImageData: createGatsbyImageData(sizes[size], imgUrl),
        },
      }
      if (size === "node") {
        edge[size].childImageSharp.gatsbyImageData.height = 84
      }
    })
    return edge
  })
}

export const mockData = {
  metaImages: {
    allFile: {
      edges: buildEdges(imagesToBeMocked),
    },
  },
  imageBasedLanguage: {
    allFile: {
      edges: [
        {
          node: {
            base: "de_our_values_2.png",
            childImageSharp: {
              original: {
                src: imgUrl,
                width: 1104,
                height: 1104,
              },
              gatsbyImageData: {
                layout: "fullWidth",
                placeholder: {
                  fallback: imgUrl,
                },
                backgroundColor: "transparent",
                images: {
                  fallback: {
                    src: imgUrl,
                    srcSet: imgUrl,
                    sizes: "100vw",
                  },
                  sources: [
                    {
                      srcSet: imgUrl,
                      type: "image/webp",
                      sizes: "100vw",
                    },
                  ],
                },
                width: 1,
                height: 1,
              },
            },
          },
        },
        {
          node: {
            base: "es_our_values_2.png",
            childImageSharp: {
              original: {
                src: imgUrl,
                width: 1104,
                height: 1104,
              },
              gatsbyImageData: {
                layout: "fullWidth",
                placeholder: {
                  fallback: imgUrl,
                },
                backgroundColor: "transparent",
                images: {
                  fallback: {
                    src: imgUrl,
                    srcSet: imgUrl,
                    sizes: "100vw",
                  },
                  sources: [
                    {
                      srcSet: imgUrl,
                      type: "image/webp",
                      sizes: "100vw",
                    },
                  ],
                },
                width: 1,
                height: 1,
              },
            },
          },
        },
      ],
    },
  },
}
